<template>
    <div>
        <control :icon="mdiMagnify" :placeholder="__('Search')" v-model="computedValue"/>
    </div>
</template>

<style>
</style>

<script>
import {mdiMagnify} from '@mdi/js'
import Control from '@/Components/Dashboard/Control'
import {computed} from "vue";


export default {
    name: 'SearchControl',
    components: {
        Control
    },
    props: {
        modelValue: {
            type: [String, Number, Boolean, Array, Object],
            default: ''
        }
    },
    emits: ['update:modelValue'],
    setup(props, {emit}) {
        const computedValue = computed({
            get: () => props.modelValue,
            set: value => {
                emit('update:modelValue', value)
            }
        })

        return {
            mdiMagnify,
            computedValue
        }
    }
}
</script>
